import React from 'react';
export function SuspiciousAttemptsTemplate() {
  return <div style={{
    fontFamily: 'Arial, sans-serif',
    maxWidth: '600px',
    margin: '0 auto'
  }} data-id="element-579">
      {/* Header with logo */}
      <div style={{
      textAlign: 'center',
      padding: '32px 0'
    }} data-id="element-580">
        <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/hnodgoqduyba7n8dlqxg6c/d4d40573-a6d5-4127-bafb-e288840a0b5f/AISCO_WORKSPACE_MARCA_POSITIVO.svg" alt="Aisco Workspace" style={{
        height: '40px',
        display: 'inline-block'
      }} data-id="element-581" />
      </div>

      {/* Main content */}
      <div style={{
      backgroundColor: '#ffffff',
      padding: '40px 32px'
    }} data-id="element-582">
        <h1 style={{
        fontSize: '24px',
        fontWeight: '600',
        color: '#1f2937',
        marginBottom: '16px',
        marginTop: '0'
      }} data-id="element-583">
          Suspicious password reset attempts detected
        </h1>

        <p style={{
        fontSize: '16px',
        color: '#4b5563',
        lineHeight: '1.6',
        marginBottom: '24px'
      }} data-id="element-584">
          Hello,
        </p>

        <p style={{
        fontSize: '16px',
        color: '#4b5563',
        lineHeight: '1.6',
        marginBottom: '24px'
      }} data-id="element-585">
          We've detected multiple password reset requests for your Aisco
          Workspace account within a short period of time.
        </p>

        <div style={{
        backgroundColor: '#fef3c7',
        padding: '20px',
        borderRadius: '8px',
        borderLeft: '4px solid #f59e0b',
        marginBottom: '32px'
      }} data-id="element-586">
          <h3 style={{
          fontSize: '16px',
          fontWeight: '600',
          color: '#92400e',
          marginTop: '0',
          marginBottom: '12px'
        }} data-id="element-587">
            Security Alert
          </h3>
          <p style={{
          margin: '0',
          color: '#78350f',
          fontSize: '14px',
          lineHeight: '1.6'
        }} data-id="element-588">
            If you didn't request these password resets, someone may be trying
            to access your account. We recommend taking immediate action to
            secure your account.
          </p>
        </div>

        <div style={{
        backgroundColor: '#f9fafb',
        padding: '20px',
        borderRadius: '8px',
        marginBottom: '32px'
      }} data-id="element-589">
          <h3 style={{
          fontSize: '16px',
          fontWeight: '600',
          color: '#1f2937',
          marginTop: '0',
          marginBottom: '12px'
        }} data-id="element-590">
            What you should do:
          </h3>
          <ul style={{
          margin: '0',
          paddingLeft: '20px',
          color: '#4b5563',
          fontSize: '14px',
          lineHeight: '1.8'
        }} data-id="element-591">
            <li data-id="element-592">
              Change your password immediately if you suspect unauthorized
              access
            </li>
            <li data-id="element-593">Review your recent account activity</li>
            <li data-id="element-594">Enable two-factor authentication for added security</li>
            <li data-id="element-595">Contact our support team if you need assistance</li>
          </ul>
        </div>

        <p style={{
        fontSize: '16px',
        color: '#4b5563',
        lineHeight: '1.6',
        marginBottom: '32px'
      }} data-id="element-596">
          If you initiated these requests, you can safely ignore this message.
          However, we recommend completing the password reset process as soon as
          possible.
        </p>

        {/* CTA Button */}
        <div style={{
        textAlign: 'center',
        margin: '32px 0'
      }} data-id="element-597">
          <a href="#" style={{
          display: 'inline-block',
          backgroundColor: '#2563eb',
          color: '#ffffff',
          padding: '14px 32px',
          borderRadius: '8px',
          textDecoration: 'none',
          fontSize: '16px',
          fontWeight: '600'
        }} data-id="element-598">
            Secure my account
          </a>
        </div>

        <p style={{
        fontSize: '14px',
        color: '#6b7280',
        lineHeight: '1.6',
        marginTop: '32px',
        marginBottom: '0'
      }} data-id="element-599">
          Need help? Contact our support team at{' '}
          <a href="mailto:support@aisco.com" style={{
          color: '#2563eb',
          textDecoration: 'none'
        }} data-id="element-600">
            support@aisco.com
          </a>
        </p>
      </div>

      {/* Footer */}
      <div style={{
      backgroundColor: '#f9fafb',
      padding: '24px 32px',
      borderTop: '1px solid #e5e7eb',
      textAlign: 'center'
    }} data-id="element-601">
        <p style={{
        fontSize: '12px',
        color: '#6b7280',
        lineHeight: '1.5',
        margin: '0'
      }} data-id="element-602">
          Aisco Europe S.A.U • Calle Playa de Riazor 22, 28042
          <br data-id="element-603" />
          Madrid, Spain
        </p>
      </div>
    </div>;
}